/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const APPLICATION_STATUS_ACCIDENT_BASE = 10;
const APPLICATION_STATUS_OPPOSING_PARTY = 20;
const APPLICATION_STATUS_DAMAGE = 30;
const APPLICATION_STATUS_INSURANCE = 40;
const APPLICATION_STATUS_DOCUMENTS = 50;
const APPLICATION_STATUS_SUMMARY = 60;
const APPLICATION_STATUS_POWER_OF_ATTORNEY = 70;
const APPLICATION_STATUS_DONE = 200;

export {
  APPLICATION_STATUS_ACCIDENT_BASE,
  APPLICATION_STATUS_DAMAGE,
  APPLICATION_STATUS_OPPOSING_PARTY,
  APPLICATION_STATUS_SUMMARY,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_DONE,
};
